import { PrecautionaryZonesModelBase } from './precautionary-zones-model';
import { ZoneFeature } from './zones-base-interfaces';
import { GeofencesService } from '../services/geofences-service';
import { IndexedDBService } from '../../indexed-db/services/db_service';
import { isOnline } from '../utils/helpers';

const isVesselOnCloud = (<any>window)["appenv"].vesselOnCloud;

export class PrecautionaryZonesModelImpl extends PrecautionaryZonesModelBase {
    async getPrecautionaryZones(): Promise<ZoneFeature[] | null> {
        await this.fetchZones();

        const precautionaryZones = this._zones;
        return precautionaryZones;
    }

    constructor(geojson?: ZoneFeature[]) {
        super();
        if (geojson) {
            this._zones = geojson;
        } else {
            setInterval(() => this.fetchZones(), 60*60*1000); // refresh the list every 1h
        }
    }

    private _zones: ZoneFeature[] | null = null;

    // NOTE: the "Precautionary Zones" rename is a UI/naming change only. The backend
    // geofence type is still 'BPR_NOGO' (the API contract), so the fetch/cache key
    // must stay 'BPR_NOGO' — otherwise the API returns nothing and no zones render.
    private static readonly GEOFENCE_TYPE = 'BPR_NOGO';

    private async fetchZones() {
        const type = PrecautionaryZonesModelImpl.GEOFENCE_TYPE;
        try {
            if (isVesselOnCloud && !isOnline()) {
                const cached = await IndexedDBService.zones.getByType(type);
                if (cached) {
                    this._zones = cached;
                }
                return;
            }
            const zones : ZoneFeature[] = await GeofencesService.fetchGeofenceByZone(type);
            if (zones) {
                this._zones = zones;
                await IndexedDBService.zones.save(type, zones);
            }
        } catch (error) {
            console.warn(`Failed to fetch ${type} zones from API, falling back to IndexedDB`, error);
            const cached = await IndexedDBService.zones.getByType(type);
            if (cached) {
                this._zones = cached;
            }
        }
    }
}
